export class MaintenanceMedia {
  url: string;
  thumbnailUrl: string;
  type: string;

  constructor(url: string, thumbnailUrl: string, type: string) {
    this.url = url ?? "";
    this.thumbnailUrl = thumbnailUrl ?? "";
    this.type = type ?? "";
  }

  toObject() {
    return {
      url: this.url,
      thumbnailUrl: this.thumbnailUrl,
      type: this.type
    };
  }
}